export const transactionTypes = [
  { value: '1', label: 'ייעוץ פנסיוני ותכנון פרישה' },
  { value: '2', label: 'החזרי מס' },
  { value: '3', label: 'תיאום מס' },
  { value: '4', label: 'ייעוץ פיננסי ותכנון מס' },
  { value: '5', label: 'טיפול בנושא ביטוח לאומי' },
  { value: '6', label: 'ניהול והפקדת הפרשות פנסיוניות' },
  { value: '7', label: 'שירותי תרגום ועריכה' },
  { value: '8', label: 'שירותי מחשוב, דיגיטל ועיצוב' },
  { value: '9', label: 'בניית אתר ו/או דף נחיתה' },
  { value: '10', label: 'עריכת סאונד' },
  { value: '11', label: 'ייעוץ שיווקי' },
  { value: '12', label: 'הדרכה דיגיטלית' },
  { value: '13', label: 'הנחה בעמלה' },
  { value: '14', label: 'שירותי גבייה ללקוחות' },
  { value: '15', label: 'הנהלת חשבונות מורחבת' },
  { value: '16', label: 'סבסוד עמלות תפעול והעברות כספים' },
  { value: '17', label: 'הקדמת תשלומים' },
];